/**
 * Состав пака «flat-sharp» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 166 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 31 из 166 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.19 },
    // 21 из 166 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.13 },
    // 16 из 166 воронок: palette → ближайшая тема по цветам
    { themeId: 'midnight-emerald', weight: 0.1 },
  ],
  fonts: [
    // 127 из 166 воронок: fontId
    { fontId: 'inter', weight: 0.77 },
    // 15 из 166 воронок: fontId
    { fontId: 'poppins', weight: 0.09 },
    // 5 из 166 воронок: fontId
    { fontId: 'roboto', weight: 0.03 },
  ],
  screenKinds: [
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.257; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.32 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.154; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.19 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.086; сюда свёрнуты Q11, Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.11 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.085; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.1 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.078
    { kind: 'N6', share: 0.1 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.052
    { kind: 'N5', share: 0.06 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.051
    { kind: 'N2', share: 0.06 },
    // средняя доля экранов по 166 воронкам (признаки.json kinds) 0.049
    { kind: 'N8', share: 0.06 },
  ],
  blocks: [
    // в 109 из 166 воронок (признаки.json blocks), подъём 0.96; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 1039 из 1212, optionIndicator 1021 из 1212
    {
      type: 'single_choice',
      weight: 0.66,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 62 из 166 воронок (признаки.json blocks), подъём 0.83; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 146 из 290
    {
      type: 'multiple_choice',
      weight: 0.37,
      settings: { optionIndicator: 'auto' },
    },
  ],
  niches: [
    // 18 из 166 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.11 },
    // 16 из 166 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.1 },
    // 15 из 166 воронок (признаки.json theme)
    { niche: 'education', weight: 0.09 },
    // 13 из 166 воронок (признаки.json theme)
    { niche: 'health', weight: 0.08 },
  ],
};
